<template src="./Edit.html"></template>

<script>
export default {
    props: {
        itemId: {
            type: Number,
            required: true,
        },
    },
    created() {
        this.$store
            .dispatch("jobs/getForEdit", this.itemId)
            .then((res) => {
                this.job = res;


            })
            .catch(() => { });
    },
    computed: {
        jobGroups() {
            return [
                ...this.$store.state.lookups.jobGroups
            ]
        },
    },
    data() {
        return {
            job: {
                isDoctor:false,
                jobDec:null
            },
        };
    },
    methods: {
        confirm() {

            this.$store
                .dispatch("jobs/edit", { id: this.itemId, payload: this.job })
                .then(() => {
                    this.back();
                })
                .catch(() => { });
        },

        back() {
            this.$emit("back");
        },
    },
};
</script>